import { get } from "api/axiosApi";
import { env } from "utils/env";
import { objToQueryString } from "utils/functions";

const url = env.REACT_APP_LEASING_API_URL;
const facilitiesURL = url + "/LeasingFacilities";

const getPagedFacilities = (filters, page, pageSize) => {
  const qs = objToQueryString({ ...filters, page, pageSize });
  return get(`${facilitiesURL}/getPagedFacilities?${qs}`);
};

const exp = {
  getPagedFacilities
};
export default exp;
